document.addEventListener('DOMContentLoaded', function() {

  /* Cart drawer */
  const cartOpen = document.getElementById('cartOpen');
  const cartClose = document.getElementById('cartClose');
  const cartDrawer = document.getElementById('cartDrawer');
  const cartOverlay = document.getElementById('cartOverlay');

  function openCart() {
    cartDrawer && cartDrawer.classList.add('open');
    cartOverlay && cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartDrawer && cartDrawer.classList.remove('open');
    cartOverlay && cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartOpen && cartOpen.addEventListener('click', openCart);
  cartClose && cartClose.addEventListener('click', closeCart);
  cartOverlay && cartOverlay.addEventListener('click', closeCart);

  /* Remove cart items */
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.cart-item-remove');
    if (!btn) return;
    const key = btn.dataset.key;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(r => r.json()).then(cart => {
      const item = btn.closest('.cart-item');
      if (item) item.remove();
      const countEl = document.getElementById('cartCount');
      const subtotalEl = document.getElementById('cartSubtotal');
      if (countEl) { countEl.textContent = cart.item_count; countEl.style.display = cart.item_count > 0 ? 'flex' : 'none'; }
      if (subtotalEl) subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
      if (cart.item_count === 0) {
        const body = document.getElementById('cartBody');
        if (body) body.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
      }
    });
  });

  /* Sticky header border on scroll */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.borderBottomColor = window.scrollY > 10 ? 'var(--border)' : 'transparent';
    }, { passive: true });
  }

  /* Active nav link */
  const path = window.location.pathname;
  document.querySelectorAll('.bottom-link').forEach(a => {
    if (a.getAttribute('href') === path || (path.includes('/collections') && a.getAttribute('href') && a.getAttribute('href').includes('/collections'))) {
      a.classList.add('active');
    }
  });

});
